import { combineReducers } from 'redux'



import titleunits from './titleunits'
import menuitems from './menuitems'
import auth from './auth'
import customers_list from './customers_list'


export default combineReducers({

    titleunits,
    menuitems,
    auth,
    customers_list

})
